import React from 'react';
import PropTypes from 'prop-types';
import { TYPE_GET_LIST, useFetcherSelector } from 'mrf/redux/ReduxHelper';
import { SortSequence } from 'mrf/utils/Sorters';
import ObjectSelect from 'mrf/view/ObjectSelect';

FetcherObjectSelect.propTypes = {
    resource: PropTypes.string.isRequired, // Resource name to save/retrieve data on redux.
    endpoint: PropTypes.string,// List endpoint
    sorter: PropTypes.func, // Sorter function.
    condition: PropTypes.func, // Whether or not to refetch list.
    dependencyList: PropTypes.array, // `useEffect` dependencyList.
}

export default function FetcherObjectSelect({
    resource,
    endpoint = `/api/${resource}`,
    query,
    sorter = SortSequence,
    condition = data => !data?.list,
    dependencyList,
    noneText,
    ...props
}) {
    useFetcherSelector({
        selector: state => state.resources?.[resource],
        type: TYPE_GET_LIST,
        resource,
        endpoint,
        query,
        condition,
        dependencyList,
        sorter,
    });

    return <ObjectSelect
        resource={resource}
        noneText={noneText}
        {...props}
    />
}
